<template>
  <v-autocomplete
    :clearable="canClear"
    :items="items"
    :loading="loading"
    :search-input.sync="search"
    :value="value"
    cache-items
    hide-no-data
    ref="ctrl"
    v-bind="$attrs"
    v-on="$listeners"
  ></v-autocomplete>
</template>
<script>
export default {
  props: ['url', 'value', 'filter', 'init', 'initItems'],
  data() {
    return {
      loading: false,
      clearable: true,
      search: null,
      items: []
    }
  },
  computed: {
    canClear() {
      if (this.$attrs.clearable === undefined) return true
      return this.$attrs.clearable
    }
  },
  mounted() {
    this.items = this.initItems || []
  },
  watch: {
    search(val) {
      val && val !== this.select && this.load(val)
    },
    value() {
      this.onSelected()
    },
    initItems(val) {
      this.items = val
    }
  },

  methods: {
    onSelected() {
      if (this.value) {
        let selected = this.items.find(
          i => i[this.$refs.ctrl.itemValue] === this.value
        )
        if (selected) {
          this.$emit('item', selected)
        }
      }
    },
    load(term) {
      this.loading = true
      this.$http
        .get(this.url.replace('{term}', term), { quiet: true })
        .then(res => {
          this.items = res.data.content
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    }
  }
}
</script>

